module.exports = __webpack_public_path__ + "img/pauli-z-root-16.1020acba.svg";